import { SxProps, Theme } from "@mui/material/styles";
import * as Global from "styles/global/global.styles";

export function cardCSS(theme: Theme): SxProps<Theme> {
  return {
    // my: "50px",
    // mx: "15rem",
    px: "4rem",
    py: "20px",
    borderRadius: "30px",
    width: { xs: "200px", md: "500px", lg: "600px" },
  };
}

export function containerCSS(theme: Theme): SxProps<Theme> {
  return {
    backgroundColor: { xs: "#F9F9F9", sm: "transparent" },
    px: { xs: "1rem", sm: "3rem", md: "8rem", lg: "3rem" },
    maxWidth: { xs: "390px", sm: "500px", md: "550px" },
  };
}

export function titleCSS(theme: Theme): SxProps<Theme> {
  return {
    textAlign: "center",
  };
}

export function buttonContainerCSS(theme: Theme): SxProps<Theme> {
  return {
    display: "flex",
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: { xs: "center", sm: "space-around" },
    gap: "1rem",
    my: "2rem",
  };
}

export function buttonCSS(theme: Theme, buttonName: string): SxProps<Theme> {
  return {
    width: { xs: "100%", sm: "250px", lg: "130px" },
    height: { xs: "50px", lg: "40px" },
    borderRadius: "100px",
    backgroundColor: buttonName === "previous" ? "#006490" : "primary",
  };
}

// ---------------------
export function textCSS(theme: Theme): SxProps<Theme> {
	return {
	  textAlign: "justify",
	  px: { xs: "2rem", sm: "1rem" },
	  my: { xs: "1rem" },
	};
  }
  
  export function downloadButtonCSS(theme: Theme): SxProps<Theme> {
	return {
	  display: "flex",
	  alignItems: "center",
	  gap: "5px",
	  border: "2px solid #efefef",
	  borderRadius: "10px",
	  backgroundColor: "#efefef",
	  margin: "5px 0",
	  px: "15px",
	  justifyContent:'space-around',
	  mb: '1rem'
	};
  }
  export function headerCSS(theme: Theme): SxProps<Theme> {
    return {
      color: Global.colors().headers,
      textTransform: "uppercase",
      fontSize: { sm: "35px" },
      textAlign: { xs: "center" },
    };
  }